module.exports = __webpack_public_path__ + "static/img/rotate06.06635fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate06.png
// module id = KL7s
// module chunks = 1